"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/config.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../../KESI2/KesiConstants");

var _RemoteControlService = require("../../../../../KESI2/Services/RemoteControlService");

var _Nugget = _interopRequireDefault(require("../Nugget.scss"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../../KESI2/KESI2Helper"));

var _Spinner = _interopRequireDefault(require("../../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../../KESI2/Stores/DataStore2"));

var _QdNugget = _interopRequireWildcard(require("../../../../../KESI2/entities/nuggets/QdNugget"));

var _DrupalQdSinglePlayerNugget = _interopRequireDefault(require("./DrupalQdSinglePlayerNugget"));

var _DrupalQdMultiplayerNugget = _interopRequireDefault(require("./DrupalQdMultiplayerNugget"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../../helpers/DeviceInfoHelper"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'qdContainer_';

var DrupalQdNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalQdNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalQdNugget);

  function DrupalQdNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalQdNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    _this.state = _objectSpread({
      waitingForActivation: false
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;

    _this.props.registerNugget(_this.props.id, _QdNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalQdNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_GROUP_ID, _DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalQdNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _QdNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      if (this.props.setFullscreenContent && this.showInFullscreen()) {
        this.props.setFullscreenContent(true);
      }
    }
    /*'
    componentWillUpdate (newProps, newState) {
      console.log('DrupalQdNugget.componentWillUpdate', newProps, newState)
      const nugget = newState.content[this.props.id]
       const active = DataStore.pathExists(`${this.props.id}.${this.props.contentPathArray.join(KESI_PATH_DELIMITER)}`, newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES])
        ? newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(KESI_PATH_DELIMITER)]
        : nugget.active
       if (newState.waitingForActivation && active !== this.active) {
        newState['waitingForActivation'] = false
      }
    }
    */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalQdNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      console.log('DrupalQdNugget.componentWillUpdate', this.props, this.state);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "showInFullscreen",
    value: function showInFullscreen() {
      var nugget = this.state.content[this.props.id];
      var fullscreenIfActive = nugget.fullscreenMode === _QdNugget.FULLSCREEN_MODES.FULLSCREEN || nugget.fullscreenMode === _QdNugget.FULLSCREEN_MODES.AUTO && nugget.mode === _QdNugget.QD_MODES.MULTPLAYER; // until design is available, always use fullscreen for normal mode

      fullscreenIfActive = fullscreenIfActive || nugget.mode === _QdNugget.QD_MODES.MULTPLAYER;
      return fullscreenIfActive;
    }
  }, {
    key: "renderMode",
    value: function renderMode() {
      var nugget = this.state.content[this.props.id];
      console.log('mode: ', nugget.mode, nugget);

      switch (nugget.mode) {
        case _QdNugget.QD_MODES.SINGLE_PLAYER:
          return /*#__PURE__*/_react["default"].createElement(_DrupalQdSinglePlayerNugget["default"], (0, _extends2["default"])({}, this.props, {
            countPoints: nugget.countUserPoints,
            affectLearnState: nugget.affectLearnState,
            disableTimer: nugget.disableTimer
          }));

        case _QdNugget.QD_MODES.MULTPLAYER:
          return /*#__PURE__*/_react["default"].createElement(_DrupalQdMultiplayerNugget["default"], this.props);

        default:
          return /*#__PURE__*/_react["default"].createElement("div", null, "Mode \"", nugget.mode, "\" not yet implemented");
      }
    }
  }, {
    key: "render",
    value: function render() {
      /**
       * @type {QdNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;

      if (active && this.showInFullscreen()) {
        return this.renderMode();
      }

      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "qdContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, this.renderMode()));
    }
  }]);
  return DrupalQdNugget;
}(_KESI2BasicComponent["default"]);

DrupalQdNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  setFullscreenContent: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired
};
DrupalQdNugget.defaultProps = {
  id: null
};
var _default = DrupalQdNugget;
exports["default"] = _default;